import React, {Component} from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import MediaQuery from 'react-responsive';
import Cookies from 'js-cookie';
import {Link} from 'react-router-dom';
import * as actions from '../state/actions';
import * as api from '../lib/api';
import Window from '../components/Window';
import Card from '../components/Card';
import Logo from '../components/Logo';
import Form from '../components/Form';
import Input from '../components/Input';
import Button from '../components/Button';
import Notification from '../components/Notification';
import CanAccessDashboard from '../security/rules/CanAccessDashboard';

class LoginScreen extends Component {
  state = {
    autoLogin: false,
    loading: false,
    error: false,
    username: '',
    password: '',
    requirePasswordChange: false,
    user: null,
    token: ''
  };

  async componentDidMount() {
    const credentials = Cookies.get('jwt');

    if (credentials) {
      this.setState({autoLogin: true});

      try {
        // Delete this cookie so we don't try again regardless of the outcome.
        Cookies.remove('jwt', {domain: '.agyleintelligence.com', path: '/'});
        // Sign the user into the dashboard automatically.
        const user = await api.autoLogin(credentials);
        this.login(credentials, user);
      }
      catch (e) {
        this.setState({autoLogin: false});
      }
    }
  }

  handleLogin = async () => {
    const {username, password} = this.state;

    this.setState({loading: true, error: false});

    try {
      const response = await api.login(username, password);
      const {token, user} = response;
      
      if(user.requirePasswordChange) {
        this.setState({requirePasswordChange: true, user: user, token:token});
        this.props.history.push('/resetPassword', {user, token});
        return;

      }

      await this.loadlabels(token);
      this.setState({loading: false, error: false});
      this.login(token, user);
    }
    catch(e) {
      this.setState({loading: false, error: true});
    }
  }

  loadlabels = async (token) => {
    const {dispatch} = this.props;
    
    try {
      const links = await api.getLabelLinks(token);
      const labels = await api.getLabels(links.labels);

      dispatch(actions.updateCompanySettings(labels));

      const logoStatus = await api.getCompanyLogoStatus(links.logo);
      
      if (logoStatus === 200) {
        dispatch(actions.updateCompanyLogo(links.logo));
      }
    }
    catch (e) {}
  }

  login = (token, user) => {
    const {dispatch} = this.props;

    if (!CanAccessDashboard(user)) {
      throw new Error('Insufficient permissions');
    }

    dispatch(actions.signIn(token, user));
  }

  renderLoginScreen = isSmallScreen => {
    const {username, password, loading, error, user, requirePasswordChange} = this.state;
    const path = '/forgotPassword';
    let resetPassword = {};

    if(requirePasswordChange) {
      resetPassword = { path, user }
    }

    return (
      <Window title="Login">
        <Content>
          <LoginContainer>
            <LogoContainer>
              <Logo size={isSmallScreen ? 60 : 80} />
            </LogoContainer>
            <H1>Login to your Account</H1>
            <LoginForm onSubmit={this.handleLogin}>
              {error && (
                <Notification error>
                  Unable to login to <span data-ignore>Agyle</span>. Please make sure your credentials are correct.
                </Notification>
              )}
              <Form.Group>
                <Input
                  large={!isSmallScreen}
                  invalid={error}
                  id="username"
                  label="Username"
                  type="text"
                  autoComplete="current-username"
                  value={username}
                  onChange={e => this.setState({username: e.target.value})}
                />
              </Form.Group>
              <Form.Group>
                <Input
                  large={!isSmallScreen}
                  invalid={error}
                  id="password"
                  label="Password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={e => this.setState({password: e.target.value})}
                />
              </Form.Group>
              <Form.Group>
                <LoginButton type="submit" large={!isSmallScreen} disabled={loading} to={resetPassword}>
                  {loading ? 'Logging in...' : 'Login'}
                </LoginButton>
              </Form.Group>

              <ForgotPasswordLink to='/forgotPassword'>Forgot Password?</ForgotPasswordLink>
            </LoginForm>
          </LoginContainer>
        </Content>
      </Window>
    );
  }

  render() {
    const {autoLogin} = this.state;

    if (autoLogin) {
      return null;
    }

    return <MediaQuery maxWidth={400} children={this.renderLoginScreen} />;
  }
}

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const LoginContainer = styled(props => <Card borderTop {...props} />)`
  flex: 1;
  max-width: 28rem;
  margin: 0 1.25rem;
`;

const LogoContainer = styled.div`
  text-align: center;
  margin-top: 1.875rem;
`;

const H1 = styled.h1`
  font-weight: 300;
  margin: 0;
  margin-top: 1.875rem;
  text-align: center;
  font-size: 2rem;

  @media (max-width: 400px) {
    font-size: 1.5rem;
  }
`;

const LoginForm = styled(Form)`
  margin: 0;
  padding: 1.875rem;
`;

const LoginButton = styled(Button)`
  display: block;
  width: 12rem;
  margin: 0 auto;
`;

const ForgotPasswordLink = styled(Link)`
  margin-top: 1.875rem;
  color: #0049ee;
  text-align: center;
  display: block;
`;

export default connect()(LoginScreen);
